import { render, staticRenderFns } from "./LangBtns.vue?vue&type=template&id=6934494e&"
import script from "./LangBtns.vue?vue&type=script&lang=js&"
export * from "./LangBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports